var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/hmrcInfoDetails',["require", "exports", "common/viewmodelbase", "models/portal", "areas/informationrequest/models/bindable", "services/settings", 'durandal/app', "areas/informationrequest/service/informationrequest-service", "areas/informationrequest/viewmodels/hmrcAPIInfo"], function (require, exports, common, Portal, VM, configuration, app, service, hmrcAPI) {
    "use strict";
    var hmrcViewModel = (function (_super) {
        __extends(hmrcViewModel, _super);
        // #region ctor
        function hmrcViewModel() {
            _super.call(this);
            this.clientInfo = new VM.InformationRequest();
            this.hasInformationReq = ko.observable(false);
            this.hasHmrcAuthorisation = ko.observable(false);
            this.noDTAInfo = ko.observable(false);
            this.spouseInfo = new VM.SpouseInfo();
            this.dtaInfo = new Array();
            this.exceptionsMessage = "";
            ko.track(this, ["hmrcInfoModel", "clientInfo", "dtaInfo"]);
            this.informationrequestService = new service.InformationRequestService();
            this.hmrcInfoModel = new hmrcAPI.hmrcAPIInfoViewModel();
        }
        // #endregion ctor
        hmrcViewModel.prototype.onActivated = function (context) {
            var host = configuration.Settings.getHost();
            this.taxYear = context.queryString.taxYear;
            this.fromPT = context.queryString.fromPT;
            this.clientName = context.queryString.clientName;
            this.clientNino = context.queryString.clientNino;
            this.clientCode = context.queryString.clientCode;
            this.clientGuid = context.queryString.clientGuid;
            this.utr = context.queryString.utr;
            this.spouseInformationString = context.queryString.spouseInformation;
            this.defaultTemplate = "default-header";
            this.checkHmrcData(this.clientGuid);
            this.loadData();
            this.showUsefulInformation();
        };
        hmrcViewModel.prototype.rootClicked = function (section) {
            section.expanded(!section.expanded());
        };
        hmrcViewModel.prototype.saveChanges = function () {
        };
        hmrcViewModel.prototype.revertChanges = function () {
            this.loadData();
        };
        hmrcViewModel.prototype.showUsefulInformation = function () {
            if (this.fromPT != null && this.fromPT == "True") {
                var showDTAInfoWarning = false;
                var shell = Portal.Context.shell;
                this.userManager = shell.userManager;
                //this.userManager.saveSettings("showDTA", { 'ShowDTA': true });
                // var aaa = this.userManager.getSettings("showDTA");
                this.userManager.getSettings("showDTA").then(function (response) {
                    if (response != null && response.toString() != "") {
                        var settings = JSON.parse(response.toString());
                        if (settings.ShowDTA == true) {
                            showDTAInfoWarning = true;
                        }
                    }
                    else {
                        showDTAInfoWarning = true;
                    }
                    if (showDTAInfoWarning == true) {
                        app.showDialog("areas/informationrequest/viewmodels/DTAInformationDialog"); // locate html file through durandal dialog mechanism
                    }
                });
            }
        };
        hmrcViewModel.prototype.loadData = function () {
            var self = this;
            self.clientInfo = new VM.InformationRequest();
            // var taxYear: number = self.taxYear;
            var details = new VM.InformationRequest();
            details.ClientName = self.clientName;
            details.UTR = self.utr;
            details.NINO = self.clientNino;
            details.TaxYear = self.taxYear;
            details.ClientCode = self.clientCode;
            this.currentYearHeader = (details.TaxYear - 1).toString() + '/' + details.TaxYear.toString().substring(2, 4);
            self.clientInfo = details;
        };
        hmrcViewModel.prototype.parseData = function (vm, response) {
            //if (this.spouseInformationString != null) {
            //    var tempSpouse = atob(this.spouseInformationString);
            //    tempSpouse = tempSpouse.replace(/"([^"]+)":/g, function ($0, $1) { return ('"' + $1[0].toLowerCase() + $1.slice(1) + '":'); });
            //    this.spouseInfo = JSON.parse(tempSpouse);
            //}
            this.spouseInfo = this.hmrcInfoModel.getSpouseInfoFromEncodedString(this.spouseInformationString);
            this.hmrcInfoModel.Load(response, this.spouseInfo, this.spouseInfo, this.currentYearHeader);
        };
        hmrcViewModel.prototype.checkHmrcData = function (clientGuid) {
            var _this = this;
            this.informationrequestService.CheckHmrcToken(clientGuid)
                .then(function (response) {
                if (response) {
                    _this.hasHmrcAuthorisation(true);
                    _this.getDataFromHmrc();
                }
            });
        };
        hmrcViewModel.prototype.getDataFromHmrc = function () {
            var _this = this;
            var self = this;
            this.informationrequestService.Refresh(self.clientGuid, self.utr, self.taxYear, self.spouseInformationString)
                .then(function (response) {
                if (response != null) {
                    _this.parseData(self, response);
                }
                else {
                    self.noDTAInfo(true);
                }
            }).fail(function (reason) {
            });
        };
        hmrcViewModel.prototype.mouseOverRoot = function (section) {
            section.mouseOver(true);
        };
        hmrcViewModel.prototype.mouseOutRoot = function (section) {
            section.mouseOver(false);
        };
        hmrcViewModel.prototype.enclosedClick = function (section, event) {
            section.enclosedPressed(!section.enclosedPressed());
        };
        return hmrcViewModel;
    }(common.ListViewModelBase));
    var instance = new hmrcViewModel();
    return instance;
});

